<template>
    <div class="flex flex-col md:flex-row gap-6">
        <div class="flex flex-col gap-6">
            <h2 class="text-2xl md:text-4xl font-semibold">Patient Overview: Initial Presentation</h2>

            <div class="">
                <h3 class="text-base md:text-2xl font-semibold mb-3">
                    An 8-year-old girl presented to a clinic in Malaysia with bilateral kidney stones
                </h3>
            </div>

            <div class="">
                <h3 class="text-base md:text-2xl font-semibold mb-3">Relevant medical history</h3>
                <div class="flex flex-col gap-3 mb-3">
                    <div class="p-5 text-white rounded bg-darkerblue">
                        She had a 1-week history of facial puffiness, anorexia, and lethargy
                    </div>
                </div>
                <div class="flex flex-col gap-3 ">
                    <div class="p-5 text-white rounded bg-maroon">
                        Two episodes of dysuria, suprapubic pain, and low-grade fever 10 months prior to presentation
                    </div>
                    <div class="p-5 text-white rounded bg-purple">
                        Passed out stones in urine three times 5 months prior to presentation
                    </div>
                </div>
            </div>

            <div class="">
                <h3 class="text-base md:text-2xl font-semibold mb-3">Family history</h3>
                <ul class="list-disc pl-4  font-light">
                    <li>
                        Born to consanguineous parents
                    </li>
                    <li>
                        The patient is the youngest of four siblings
                        <ul class="list-inside list-['-_'] pl-6">
                            <li>Her mother had a miscarriage during her fourth pregnancy</li>
                            <li>Her older sister passed away aged 9 years due to renal failure</li>
                        </ul>
                    </li>
                    <li>The patient’s paternal uncle had kidney stones aged 18 years but is currently well</li>
                </ul>
            </div>
        </div>

        <img src="@/assets/img/graphics/pediatric/pediatric-child.svg" alt="Girl body" :style="{ maxHeight: '780px' }" />
    </div>
</template>
